var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0081 3.75H12.1319C11.9362 3.74984 11.7424 3.78822 11.5616 3.86294C11.3807 3.93767 11.2164 4.04729 11.0779 4.18553C10.9394 4.32377 10.8296 4.48794 10.7545 4.66865C10.6795 4.84936 10.6408 5.04308 10.6406 5.23875V11.875L24.4769 15.9375L37.5006 11.875V5.23875C37.5005 5.04298 37.4617 4.84915 37.3866 4.66836C37.3115 4.48757 37.2015 4.32335 37.0629 4.18509C36.9243 4.04683 36.7598 3.93724 36.5788 3.86258C36.3978 3.78793 36.2039 3.74967 36.0081 3.75Z",
    fill: "#41A5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5006 11.875H10.6406V20L24.4769 22.4375L37.5006 20V11.875Z",
    fill: "#2B7CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 20V28.125L23.6631 29.75L37.5006 28.125V20H10.6406Z",
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1319 36.25H36.0069C36.2028 36.2505 36.3968 36.2124 36.5779 36.1378C36.7591 36.0632 36.9237 35.9536 37.0624 35.8154C37.2012 35.6771 37.3113 35.5128 37.3865 35.3319C37.4617 35.1511 37.5005 34.9571 37.5006 34.7613V28.125H10.6406V34.7613C10.6408 34.9569 10.6795 35.1506 10.7545 35.3314C10.8296 35.5121 10.9394 35.6762 11.0779 35.8145C11.2164 35.9527 11.3807 36.0623 11.5616 36.1371C11.7424 36.2118 11.9362 36.2502 12.1319 36.25Z",
    fill: "#103F91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.5431 10.25H10.6406V30.5625H20.5431C20.9377 30.5605 21.3156 30.4032 21.595 30.1245C21.8744 29.8458 22.0327 29.4683 22.0356 29.0738V11.7387C22.0327 11.3442 21.8744 10.9667 21.595 10.688C21.3156 10.4093 20.9377 10.252 20.5431 10.25Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.7294 11.0625H10.6406V31.375H19.7294C20.124 31.373 20.5019 31.2157 20.7812 30.937C21.0606 30.6583 21.2189 30.2808 21.2219 29.8863V12.5512C21.2189 12.1567 21.0606 11.7792 20.7812 11.5005C20.5019 11.2218 20.124 11.0645 19.7294 11.0625Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.7294 11.0625H10.6406V29.75H19.7294C20.124 29.748 20.5019 29.5907 20.7812 29.312C21.0606 29.0333 21.2189 28.6558 21.2219 28.2612V12.5512C21.2189 12.1567 21.0606 11.7792 20.7812 11.5005C20.5019 11.2218 20.124 11.0645 19.7294 11.0625Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.9156 11.0625H10.6406V29.75H18.9156C19.3102 29.748 19.6881 29.5907 19.9675 29.312C20.2469 29.0333 20.4052 28.6558 20.4081 28.2612V12.5512C20.4052 12.1567 20.2469 11.7792 19.9675 11.5005C19.6881 11.2218 19.3102 11.0645 18.9156 11.0625Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9925 11.0625H18.915C19.3103 11.0622 19.6895 11.2188 19.9694 11.498C20.2493 11.7771 20.4068 12.156 20.4075 12.5513V27.4488C20.4068 27.844 20.2493 28.2229 19.9694 28.5021C19.6895 28.7812 19.3103 28.9378 18.915 28.9375H3.9925C3.79673 28.9378 3.60281 28.8996 3.42182 28.8249C3.24084 28.7503 3.07634 28.6407 2.93774 28.5024C2.79913 28.3642 2.68913 28.1999 2.61402 28.0191C2.53891 27.8384 2.50016 27.6445 2.5 27.4488V12.5513C2.50016 12.3555 2.53891 12.1617 2.61402 11.9809C2.68913 11.8001 2.79913 11.6358 2.93774 11.4976C3.07634 11.3593 3.24084 11.2497 3.42182 11.1751C3.60281 11.1004 3.79673 11.0622 3.9925 11.0625Z",
    fill: "url(#paint0_linear_465_121)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62578 22.4854C8.65453 22.7154 8.67453 22.9154 8.68328 23.0866H8.71828C8.73078 22.9241 8.75828 22.7279 8.79953 22.4991C8.84078 22.2704 8.87703 22.0766 8.91078 21.9179L10.4795 15.1591H12.5095L14.1345 21.8166C14.2292 22.2285 14.2968 22.646 14.337 23.0666H14.3645C14.3944 22.6572 14.4508 22.2501 14.5333 21.8479L15.832 15.1504H17.6783L15.3983 24.8354H13.2395L11.6933 18.4279C11.6483 18.2429 11.5974 18.0021 11.5408 17.7054C11.4841 17.4087 11.4491 17.1921 11.4358 17.0554H11.4095C11.392 17.2129 11.357 17.4466 11.3045 17.7566C11.252 18.0679 11.2108 18.2966 11.1795 18.4466L9.72578 24.8391H7.53078L5.23828 15.1591H7.11328L8.52703 21.9316C8.56923 22.1144 8.60218 22.2993 8.62578 22.4854Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_121",
    x1: 5.6175,
    y1: 9.8925,
    x2: 17.29,
    y2: 30.1075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordicon);
export default __webpack_public_path__ + "static/media/wordicon.799a13f30e94820744cea5db6c09982b.svg";
export { ForwardRef as ReactComponent };